import { render, staticRenderFns } from "./DataBox.vue?vue&type=template&id=34e608bf&scoped=true&"
import script from "./DataBox.vue?vue&type=script&lang=js&"
export * from "./DataBox.vue?vue&type=script&lang=js&"
import style0 from "./DataBox.vue?vue&type=style&index=0&id=34e608bf&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34e608bf",
  null
  
)

export default component.exports